module.exports = __webpack_public_path__ + "img/stock6.9e72db2d.png";